import { render, staticRenderFns } from "./CancellationInfo.vue?vue&type=template&id=3ad63036&scoped=true&"
import script from "./CancellationInfo.vue?vue&type=script&lang=js&"
export * from "./CancellationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CancellationInfo.vue?vue&type=style&index=0&id=3ad63036&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad63036",
  null
  
)

export default component.exports